import { render, staticRenderFns } from "./Agregar.vue?vue&type=template&id=da4621e0&scoped=true"
import script from "./Agregar.vue?vue&type=script&lang=js"
export * from "./Agregar.vue?vue&type=script&lang=js"
import style0 from "./Agregar.vue?vue&type=style&index=0&id=da4621e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4621e0",
  null
  
)

export default component.exports